import { EMPTY_MAINTENANCE_STATE, type MaintenanceState } from '@rb/shared/maintenance.types';
import { pickFlavor, wrapFlavors } from '@rb/shared/r2-flavor';
import { callEdgeFunction } from '../supabase.client';

/** R2 발행본을 web2/web3 로 분리. 미발행/누락은 OFF. */
export async function fetchMaintenanceFlavored(
  channel: string
): Promise<{ web2: MaintenanceState; web3: MaintenanceState }> {
  const res = await callEdgeFunction<{ config: unknown | null }>('maintenance', { channel });
  if (!res.config)
    return { web2: { ...EMPTY_MAINTENANCE_STATE }, web3: { ...EMPTY_MAINTENANCE_STATE } };
  return {
    web2: pickFlavor<MaintenanceState>(res.config, 'web2') ?? { ...EMPTY_MAINTENANCE_STATE },
    web3: pickFlavor<MaintenanceState>(res.config, 'web3') ?? { ...EMPTY_MAINTENANCE_STATE },
  };
}

/** 두 flavor 점검 상태를 nested 로 R2 발행. */
export async function publishMaintenanceFlavored(
  channel: string,
  flavored: { web2: MaintenanceState; web3: MaintenanceState }
): Promise<void> {
  await callEdgeFunction('maintenance', {
    channel,
    config: wrapFlavors(flavored.web2, flavored.web3),
  });
}
